export default {
      id: "uspCard-GuaranteedIncome-usage",
      viewBox: "0 0 200 60",
      url: __webpack_public_path__ + "sprite.svg#uspCard-GuaranteedIncome",
      toString: function () {
        return this.url;
      }
    }